export enum ETrafficConditions {
	ALLOWED = 'allowed',
	FORBIDDEN = 'forbidden',
	BY_AGREEMENT = 'by_agreement',
}

export enum ESourceRelationStatuses {
	VERIFICATION = 'verification',
	NOT_JOINED = 'not_joined',
	JOINED = 'joined',
	REJECTED = 'rejected',
	DISABLED = 'disabled',
}
